export const validatePhoneNumber = (countryCode, phone) => {
    const trimmed = (phone || '').trim();
    if (!trimmed) return 'Phone number is required';
    if (!/^\d+$/.test(trimmed)) return 'Phone number must contain only digits';

    switch (countryCode) {
        case '+94':
            if (!/^7[0-9]{8}$/.test(trimmed)) {
                return 'Please enter a valid Sri Lankan mobile number (e.g. 771234567)';
            }
            break;
        case '+91':
            if (!/^[6-9][0-9]{9}$/.test(trimmed)) {
                return 'Please enter a valid Indian mobile number (e.g. 9876543210)';
            }
            break;
        case '+1':
            if (!/^[2-9][0-9]{9}$/.test(trimmed)) {
                return 'Please enter a valid US mobile number (e.g. 2015550123)';
            }
            break;
        case '+44':
            if (!/^7[0-9]{9}$/.test(trimmed)) {
                return 'Please enter a valid UK mobile number (e.g. 7123456789)';
            }
            break;
        case '+61':
            if (!/^4[0-9]{8}$/.test(trimmed)) {
                return 'Please enter a valid Australian mobile number (e.g. 412345678)';
            }
            break;
        default:
            if (trimmed.length < 7 || trimmed.length > 15) {
                return 'Please enter a valid mobile number';
            }
    }
    return '';
};

export const validateFullName = (fullNameRaw) => {
    const fullName = (fullNameRaw || '').trim();
    if (!fullNameRaw) {
        return 'Full Name is required';
    } else if (!fullName) {
        return 'Full Name cannot consist of only spaces';
    } else if (fullName.length > 50) {
        return 'Full Name cannot exceed 50 characters';
    } else if (!/^[a-zA-Z\s.'-]+$/.test(fullName)) {
        return 'Full Name can only contain letters, spaces, hyphens, apostrophes, and periods';
    } else if (/\s{2,}/.test(fullName)) {
        return 'Multiple consecutive spaces are not allowed';
    }
    return '';
};

export const validateDateOfBirth = (dateOfBirth) => {
    if (!dateOfBirth) {
        return 'Date of Birth is required';
    }
    const dobDate = new Date(dateOfBirth);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (isNaN(dobDate.getTime())) {
        return 'Please enter a valid date';
    }
    if (dobDate > today) {
        return 'Future dates are not allowed';
    }
    return '';
};

export const getPhoneMaxLength = (countryCode) => {
    switch (countryCode) {
        case '+94': return 9; // Sri Lanka
        case '+61': return 9; // Australia
        case '+91': return 10; // India
        case '+1': return 10; // US
        case '+44': return 10; // UK
        default: return 15; // default max length for other countries
    }
};
